/* swym-inquire.js — Wishlist: replace “Add to cart” with “INQUIRE NOW” for items > $30k CAD
   and route image/title clicks to WhatsApp for those items. */
(() => {                                            
  // --- CONFIG ---
  const PRICE_THRESHOLD = 20000;                          // CAD
  const PHONE  = '16049077777';                           // WhatsApp number (no + or spaces)
  const PREFIX = "Hi, I'm interested in";                 // Message prefix
  const DEBUG  = false;                                   // set true to console.log

  // --- HELPERS ---
  const isMobile = /Android|iPhone|iPad|iPod|Opera Mini|IEMobile/i.test(navigator.userAgent);
  const log = (...a) => DEBUG && console.log('[Swym Inquire]', ...a);

  function buildWA(title, url) {
    const msg = `${PREFIX} ${title} (${url})`;
    const enc = encodeURIComponent(msg);
    return isMobile
      ? `https://wa.me/${PHONE}?text=${enc}`
      : `https://web.whatsapp.com/send?phone=${PHONE}&text=${enc}`;
  }

  function parsePrice(text) {
    if (!text) return 0;
    const nums = (text.match(/[\d.,]+/g) || [])
      .map(s => parseFloat(s.replace(/,/g, '')))
      .filter(Number.isFinite);
    return nums.length ? Math.max(...nums) : 0;
  }

  function makeInquireBtn(title) {
  const a = document.createElement('a');
  a.className = 'swymcs-wishlist-inquire-button';
  a.href =
    'https://api.whatsapp.com/send/?phone=16049077777&text=Hi%21%20I%E2%80%99m%20interested%20in%20the%20product.%20I%E2%80%99d%20love%20to%20come%20see%20it%20in%20store%20and%20check%20it%20out.&type=phone_number&app_absent=0';
  a.target = '_blank';
  a.rel = 'noopener';
  a.textContent = 'Inquire Now';
  return a;
}



  // Prevent Swym from intercepting our clicks (don’t open detail)
  document.addEventListener('click', (ev) => {
    const a =
      ev.target.closest('.swymcs-wishlist-inquire-button') ||
      ev.target.closest('.swymcs-inquire-link');
    if (!a) return;
    ev.stopImmediatePropagation();
    ev.stopPropagation();
    if (a.target === '_blank') {
      ev.preventDefault();
      window.open(a.href, '_blank', 'noopener');
    }
  }, true);

  // Compute price/title/url INSIDE a specific card
  function priceOf(card) {
    let p = 0;
    card.querySelectorAll(':scope .swym-product-price, :scope .swym-item-price, :scope [class*="price"], :scope .money')
      .forEach(el => { p = Math.max(p, parsePrice(el.textContent)); });
    if (!p) p = parsePrice(card.textContent);
    return p;
  }
  function titleOf(card) {
    const el = card.querySelector(':scope .swym-product-title, :scope .swym-title, :scope [class*="title"], :scope a[href*="/products/"]');
    return (el?.textContent || 'Item').trim();
  }
  function urlOf(card) {
    const a = card.querySelector(':scope a[href*="/products/"]');
    return a?.href || location.href;
  }
  function findCTA(card) {
    return Array.from(card.querySelectorAll(':scope button, :scope a'))
      .find(b => /add\s*to\s*cart|added\s*to\s*cart/i.test((b.textContent || '').trim())) ||
      card.querySelector(':cope .swym-add-to-cart, :scope .swym-add-to-cart-btn') ||
      null;
  }
  function actionsContainer(card) {
    return card.querySelector(':scope .swym-wishlist-item-actions, :scope .swym-actions, :scope [class*="actions"]') ||
           card.querySelector(':scope .swym-product-price, :scope .swym-item-price, :scope [class*="price"]') ||
           card;
  }

  // NEW: route all product links (image/title) inside a card to WhatsApp
  function hijackCardLinks(card, title, pdpUrl) {
  const linkSel = ':scope a[href*="/products/"], :scope .swym-product-title a, :scope .swym-title a';
  const links = card.querySelectorAll(linkSel);
  links.forEach(a => {
    if (a.classList.contains('swymcs-inquire-link')) return;
    a.classList.add('swymcs-inquire-link');
    a.href = pdpUrl; // keep original product URL
    a.removeAttribute('target');
    a.removeAttribute('rel');
  });

  // If the image isn’t wrapped in a link, make it clickable to the product page
  const img = card.querySelector(':scope img');
  if (img && !img.closest('a')) {
    if (!img.classList.contains('swymcs-inquire-img')) {
      img.classList.add('swymcs-inquire-img');
      img.style.cursor = 'pointer';
      img.addEventListener('click', (e) => {
        e.stopPropagation();
        window.location.href = pdpUrl;
      }, true);
    }
  }
}


  // --- CORE TRANSFORMS ---
  function transformGrid(root) {
    const cards = root.querySelectorAll(
      '.swym-simple-wishlist-item, .swym-wishlist-item, .swym-item'
    );

    cards.forEach((card) => {
      const price = priceOf(card);
      if (price <= PRICE_THRESHOLD) return;

      const title = titleOf(card);
      const href  = urlOf(card);
      const cta   = findCTA(card);

      // Replace/append CTA
      if (cta && !cta.classList.contains('swymcs-wishlist-inquire-button')) {
       cta.replaceWith(makeInquireBtn(title));
      } else if (!card.querySelector(':scope .swymcs-wishlist-inquire-button')) {
        
        actionsContainer(card).appendChild(makeInquireBtn(title));
      }

      // Route image/title links to WhatsApp
      hijackCardLinks(card, title, href);

      // de-dupe
      const inqs = card.querySelectorAll(':scope .swymcs-wishlist-inquire-button');
      for (let i = 1; i < inqs.length; i++) inqs[i].remove();
    });
  }

  function transformDetail(root) {
    const detail = root.querySelector('.swym-simple-wishlist-detail, .swym-wishlist-detail');
    if (!detail) return;

    const price = parsePrice(detail.textContent);
    if (price <= PRICE_THRESHOLD) return;

    const titleEl = detail.querySelector('.swym-product-title, [class*="title"], h1, h2, a[href*="/products/"]');
    const linkEl  = detail.querySelector('a[href*="/products/"]');
    const title   = (titleEl?.textContent || 'Item').trim();
    const href    = linkEl?.href || location.href;

    // Replace CTA
    let cta = Array.from(detail.querySelectorAll('button, a'))
      .find(b => /add\s*to\s*cart|added\s*to\s*cart/i.test((b.textContent || '').trim())) ||
      detail.querySelector('.swym-add-to-cart, .swym-add-to-cart-btn');

    if (cta && !cta.classList.contains('swymcs-wishlist-inquire-button')) {
      cta.replaceWith(makeInquireBtn(title));
    } else if (!detail.querySelector('.swymcs-wishlist-inquire-button')) {
      (detail.querySelector('[class*="price"]') || detail).appendChild(makeInquireBtn(title, href));
    }

    // Route any product links in the detail view to WhatsApp as well
    const linkSel = 'a[href*="/products/"], .swym-product-title a, .swym-title a';
    detail.querySelectorAll(linkSel).forEach(a => {
      if (a.classList.contains('swymcs-inquire-link')) return;
      a.classList.add('swymcs-inquire-link');
      a.href = buildWA(title, href);
      a.target = '_blank';
      a.rel = 'noopener';
      a.addEventListener('click', e => e.stopPropagation(), true);
    });

    // de-dupe
    const inqs = detail.querySelectorAll('.swymcs-wishlist-inquire-button');
    for (let i = 1; i < inqs.length; i++) inqs[i].remove();
  }

  function transformModal() {
    const root =
      document.querySelector('.swym-wishlist-detail-content') ||  // grid body
      document.querySelector('.swym-simple-wishlist-container') || // legacy
      document.querySelector('.swym-modal, .swym-ui-component, .swym-drawer') ||
      null;
    if (!root) return;

    transformGrid(root);
    transformDetail(root);
  }

  // --- KEEP IT STICKY ON RE-RENDERS ---
  let scheduled = false;
  const schedule = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => { scheduled = false; transformModal(); });
  };

  transformModal();
  setTimeout(transformModal, 250);
  setTimeout(transformModal, 750);
  setTimeout(transformModal, 1500);

  new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });

  window.SwymCallbacks = window.SwymCallbacks || [];
  window.SwymCallbacks.push(() => schedule());

  log('initialized');

  

})(); // <-- closes your main wishlist script


